import { render, staticRenderFns } from "./KommunalIDPLogin.vue?vue&type=template&id=1604cb59&scoped=true&"
import script from "./KommunalIDPLogin.vue?vue&type=script&lang=js&"
export * from "./KommunalIDPLogin.vue?vue&type=script&lang=js&"
import style0 from "./KommunalIDPLogin.vue?vue&type=style&index=0&id=1604cb59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1604cb59",
  null
  
)

export default component.exports